/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/heroSection.config.json";
import { StorageModule } from "@vlinder-web/storage-module-react";

export interface IHeroSectionMethods extends IPluginMethodMap {
  getHeroSectionProps(args: any): Promise<any>;
}

export class HeroSectionService implements IAgentPlugin {
  readonly methods: IHeroSectionMethods;

  constructor() {
    this.methods = {
      getHeroSectionProps: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    const storageSrv = StorageModule.getInstance();
    const localStorage = storageSrv?.get("theme", "local");
    const brandLogo = localStorage?.bandLogo;
    const openReg = localStorage?.openRegEnabled;
    console.log(localStorage);
    console.log(openReg);
    let logoChanged = {
      ...config,
      // heroOrg: {
      //   ...config.heroOrg,
      //   image: brandLogo,
      // },
      // "heroOrg": {
      //   "name": "theLostTribe",
      //   "image": "https://s3.ca-central-1.amazonaws.com/io.vlinder.gem-prod/logo/tribe_24/lostribe_theme_logo_.png",
      //   "height": 60,
      //   "width": 70
      // }
      heroDarkButtonItem: {
        name: "Sign Up Now",
        // link: "/register",
        link: openReg ? "/register" : "/sign-in",
      },
    };

    return { ...(logoChanged || {}) };
  }
}
